// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'knobs';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    d='M9.001 4.1V1.395m0 15.213V7.59m-5.75 2.824v-9.02m0 15.214v-2.705m11.4-3.489v-9.02m0 15.214v-2.705M9 4.1a1.745 1.745 0 1 0 0 3.49A1.745 1.745 0 0 0 9 4.1zm-5.75 6.314a1.745 1.745 0 1 0 0 3.49 1.745 1.745 0 0 0 0-3.49zm11.5 0a1.745 1.745 0 1 0 0 3.49 1.745 1.745 0 0 0 0-3.49z'
  />
);

export const viewBox = '0 0 18 18';
